import { useSelector } from 'react-redux';

import { setCountDecimals } from 'utils';

import { orderbookSelector } from 'store/entities/market/orderbook/selectors';

import { OrderbookT } from 'types';

import './OrderBookTab.scss';

enum Orders {
  Buy = 'buy',
  Sell = 'sell',
}

type SliceT = {
  quantity: number;
  price: number;
};

interface IPropsOrderBookTab {
  decimal: number;
}

const OrderBookTab: React.FC<IPropsOrderBookTab> = ({ decimal }): JSX.Element => {
  const orderbook: OrderbookT = useSelector(orderbookSelector);
  const { buy, sell } = orderbook;

  const renderOrdersBookAsk = (slice: SliceT, key: number, accumulatedVolume: number, totalVolume: number) => {
    let volumeBarWidth = (accumulatedVolume / totalVolume) * 100;
    if (volumeBarWidth < 2) volumeBarWidth = 2;
    const precision = 4;

    const price = setCountDecimals(slice.price || 0, decimal);
    const quantity = slice.quantity.toFixed(precision);

    return (
      <div className="order-book-row" key={key}>
        <span className="order-book-row-volume-bar" style={{ width: `${volumeBarWidth}%` }} />
        <span className="order-book-row-price">{price}</span>
        <span className="order-book-row-quantity">{quantity}</span>
      </div>
    );
  };

  const renderOrdersBookBid = (slice: SliceT, key: number, accumulatedVolume: number, totalVolume: number) => {
    let volumeBarWidth = (accumulatedVolume / totalVolume) * 100;
    if (volumeBarWidth < 2) volumeBarWidth = 2;
    const precision = 4;

    const price = setCountDecimals(slice.price || 0, decimal);
    const quantity = slice.quantity.toFixed(precision);

    return (
      <div className="order-book-row" key={key}>
        <span className="order-book-row-volume-bar" style={{ width: `${volumeBarWidth}%` }} />
        <span className="order-book-row-quantity">{quantity}</span>
        <span className="order-book-row-price">{price}</span>
      </div>
    );
  };

  const renderOrdersBook = (data: SliceT[], orderType: Orders) => {
    const totalVolume = data.reduce((sum, { quantity }) => sum + quantity, 0);

    let accumulatedVolume = 0;

    const result = data.map((slice, index) => {
      accumulatedVolume += slice.quantity;
      return orderType === Orders.Sell
        ? renderOrdersBookAsk(slice, index, accumulatedVolume, totalVolume)
        : renderOrdersBookBid(slice, index, accumulatedVolume, totalVolume);
    });

    return result;
  };

  return (
    <>
      {buy?.length || sell?.length ? (
        <div className="orders-book-container">
          <div className="orders-book-header">
            <div className="col">
              <p>{_t('Quantity', 'MARKET_INFO.QUANTITY')}</p>
              <p>{_t('Price', 'MARKET_INFO.PRICE')}</p>
            </div>
            <div className="col">
              <p>{_t('Price', 'MARKET_INFO.PRICE')}</p>
              <p>{_t('Quantity', 'MARKET_INFO.QUANTITY')}</p>
            </div>
          </div>

          <div className="orders-book-body">
            <div className="order-book-bids">{renderOrdersBook(buy, Orders.Buy)}</div>
            <div className="order-book-asks">{renderOrdersBook(sell, Orders.Sell)}</div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default OrderBookTab;
